export enum ProductDetailsTestIds {
  ALL_COLORS_FILTER = 'product-details-all-colors-filter',
  COMBINATION_PACK_CHIP = 'product-details-combination-pack-chip',
  COMBINATION_UNAVAILABLE_GRID = 'product-details-combination-unavailable-grid',
  MASS_ACTION_BAR = 'product-details-mass-action-bar',
  MASS_ACTION_PASTE_TO_ALL = 'product-details-mass-action-paste-to-all',
  MEDIA_COLOR_SELECTOR = 'product-details-media-color-selector',
  MEDIA_COLOR_SELECTOR_TOGGLE = 'product-details-media-color-selector-toggle',
}
